export const serializeActor = actor => `${actor.actorType}:${actor.id}`;
export const parseActor = key => {
  const separatorIndex = key.indexOf(':');
  if (separatorIndex === -1) {
    throw new Error(`Malformed ActorKey, expected "<actorType>:<id>": ${key}`);
  }
  return {
    actorType: key.slice(0, separatorIndex),
    id: key.slice(separatorIndex + 1)
  };
};
export const parseActorKeys = values => values.map(value => parseActor(value));